<template>
  <v-alert
    v-if="visible"
    color="#e8f5e9"
    border="left"
    elevation="2"
    dismissible
    close-label="ปิดประกาศ"
    class="promptpay-qr-notice mb-5"
    data-test="qr-notice"
    @input="close"
  >
    <v-icon color="#2e7d32" class="mr-2">mdi-qrcode-scan</v-icon>
    <strong>ใหม่: มีบริการ สร้าง QR Code จากแอปร้านค้า แล้วนะ</strong>
    <span class="ml-1">
      (K Shop / แม่มณี / เป๋าตัง ฯลฯ) เจ้าของร้านตั้งค่าได้ที่
    </span>
    <router-link
      :to="{ name: 'setting-business-branch' }"
      class="promptpay-qr-link"
    >
      ตั้งค่า &gt; ข้อมูลสาขา
    </router-link>
    <span class="ml-1">ระบบจะใส่ยอดเงินตามบิลให้อัตโนมัติ</span>
  </v-alert>
</template>

<script>
import { dismissNotice, isNoticeDismissed, isNoticeVisible } from './qrNoticeWindow';

export default {
  data: () => ({
    visible: false,
  }),
  created() {
    this.visible = isNoticeVisible() && !isNoticeDismissed();
  },
  methods: {
    close() {
      this.visible = false;
      dismissNotice();
    },
  },
};
</script>

<style scoped>
.promptpay-qr-notice {
  color: #1b5e20;
  font-weight: 500;
}

.promptpay-qr-link {
  color: #1b5e20;
  font-weight: 700;
  text-decoration: underline;
}
</style>
